import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { toApplicantTableItem } from '../../../RentalPortalApplicant'
import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  TableRowActions,
  useTableRowActions,
  useTableRowModClassName,
} from '../../../Table'

import {
  getIsApplicantRowActive,
  renderCell,
} from './RentalPortalApplicantsTableRow.utils'

import * as styles from './RentalPortalApplicantsTableRow.module.css'

function RentalPortalApplicantsTableRow({
  Actions = TableRowActions,
  actionsColumnWidth,
  columns,
  emptyColumnSize,
  focusedRow,
  getArrowNavigationItemProps,
  hideCheckbox,
  index,
  isResizing,
  isSelected,
  isShort,
  item,
  resizingColumn,
  scrollRef,
  showCellBorder,
  ...restProps
}) {
  const { t } = useTranslation()

  const {
    handleClick,
    handleMouseDown,
    handleMouseEnter,
    handleMouseLeave,
    handleSelect,
  } = useTableRowActions({ item, ...restProps })

  const { id } = item

  const qaProps = getTableRowQaProps()

  const className = useTableRowModClassName({
    className: styles.RentalPortalApplicantsTableRow,
    isActive: getIsApplicantRowActive({ focusedRow, id }),
    isSelected,
  })

  const applicant = toApplicantTableItem(item)

  return (
    <div
      {...qaProps}
      {...getArrowNavigationItemProps?.(index)}
      className={className}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {Actions ? (
        <Actions
          disabled={hideCheckbox}
          selected={isSelected}
          width={actionsColumnWidth}
          onChange={handleSelect}
        />
      ) : null}
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderCell({
            isActive: column.name === resizingColumn,
            isResizing,
            isShort,
            item: applicant,
            name: column.name,
            scrollRef,
            showCellBorder,
            t,
            width: column.width,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
    </div>
  )
}

export default RentalPortalApplicantsTableRow
